export const projects = [
  {
    id: 18,
    title: "PulseBeauty Studio",
    description:
      "Commercial website for PulseBeauty Studio — electrolysis hair removal studio in Auckland, NZ. Built with React 19, Vite 7, Tailwind CSS 4. Features multilingual support (en/ru), SEO optimization, React Router 7, Framer Motion animations, and Swiper for galleries.",
    role: "Front-End Developer",
    tech: ["React", "Tailwind CSS", "Framer Motion"],
    image: "/images/pulse.png",
    demo: "https://www.pulsebeauty-studio.com/en",
    code: "https://github.com/chasov-artem/daria-zhuravel",
    logoImage: "/images/pulse1.png",
    featured: true,
    featuredOrder: 1,
    caseStudy: {
      problem:
        "Electrolysis studio needed a modern, multilingual website with booking, gallery, and SEO.",
      solution:
        "React 19 + Vite 7 + Tailwind CSS 4 with en/ru i18n, Framer Motion, Swiper, SEO setup.",
      highlight:
        "Commercial project, multilingual, SEO, React 19, Tailwind CSS 4.",
    },
  },
  {
    id: 17,
    title: "Nanny Services",
    description:
      "Nanny Services is a React-based web application for a nanny services company that lets users browse nanny profiles, filter by price and rating, sort alphabetically, and book appointments. Authenticated users can save favorites, synced with Firebase Realtime Database, and access a private favorites page.",
    role: "Front-End Developer",
    tech: ["React", "Firebase", "HTML", "CSS"],
    image: "/images/nannies.png",
    demo: "https://nannies.chasov-dev.com/",
    code: "https://github.com/chasov-artem/Nanny.Services/",
    logoImage: "/images/nannies1.png",
    featured: true,
    featuredOrder: 6,
    caseStudy: {
      problem:
        "Nanny agency needed a modern web app for browsing profiles, filtering, and booking.",
      solution:
        "Built React app with Firebase Auth & Realtime DB for favorites sync and private user pages.",
      highlight: "Firebase integration, auth flow, real-time data sync.",
    },
  },
  {
    id: 16,
    title: "phrase-editor",
    description:
      "Phrase Editor is a browser-based tool for editing phrase lists with support for up to 50,000+ rows. It’s built with React 19, TypeScript, Tailwind CSS, Zustand for state, and it uses Web Workers for heavy text processing.",
    role: "Front-End Developer",
    tech: ["React", "TS", "Tailwind CSS", "Zustand", "Web Workers"],
    image: "/images/phrase-editor.png",
    demo: "https://phrase-editor.chasov-dev.com/",
    code: "https://github.com/chasov-artem/phrase-editor",
    logoImage: "/images/phrase-editor1.png",
    featured: true,
    featuredOrder: 3,
    caseStudy: {
      problem:
        "Need to edit large phrase lists (50k+ rows) without freezing the browser.",
      solution:
        "Built React 19 + TypeScript app with Web Workers for heavy processing, Zustand for state.",
      highlight: "Web Workers, performance optimization, TypeScript, Tailwind.",
    },
  },
  {
    id: 15,
    title: "mini-messenger",
    description:
      "A real-time messaging application built with Next.js and Node.js, featuring WebSocket-based instant messaging and user authentication. The application uses a modern tech stack including React 19, TypeScript, Redux Toolkit, Express, Prisma ORM, and SQLite, deployed on Vercel (frontend) and Render (backend) with custom domain configuration.",
    role: "Full-Stack Developer",
    tech: ["Next", "TS", "HTML", "CSS", "WebSocket"],
    image: "/images/mm.png",
    demo: "https://mini-messenger.chasov-dev.com/",
    code: "https://github.com/chasov-artem/mini-messenger/",
    logoImage: "/images/mm1.png",
    featured: true,
    featuredOrder: 2,
    caseStudy: {
      problem:
        "Real-time chat app with auth, WebSocket messaging, and full-stack deployment.",
      solution:
        "Next.js + Express, Prisma, SQLite, WebSocket. Deployed on Vercel + Render.",
      highlight: "Full-Stack, WebSocket, Next.js, TypeScript, Prisma.",
    },
  },
  {
    id: 14,
    title: "LearnLingo",
    description:
      "A web application for an online language learning platform. Built with React, Firebase (Auth & Realtime Database).",
    role: "Front-End Developer",
    tech: ["React", "Firebase", "CSS"],
    image: "/images/learnlingo.png",
    demo: "https://learnlingo.chasov-dev.com/",
    code: "https://github.com/chasov-artem/english",
    logoImage: "/images/learnlingo1.png",
  },
  {
    id: 13,
    title: "Billiard-servis",
    description:
      "This is my first commercial web catalog project for billiards products. It features CSV product import, an admin panel for catalog management, and a responsive, modern UI.",
    role: "Front-End Developer",
    tech: ["React", "Firebase", "CSS"],
    image: "/images/billiard.png",
    demo: "https://www.billiard-servis.com/",
    code: "https://github.com/chasov-artem/billirds-catalog",
    logoImage: "/images/billiard1.png",
    featured: true,
    featuredOrder: 5,
    caseStudy: {
      problem:
        "Billiards store needed an e-commerce catalog with admin panel and product import.",
      solution:
        "React + Firebase catalog with CSV import, admin panel, responsive UI.",
      highlight: "Commercial project, admin panel, CSV import, Firebase.",
    },
  },
  {
    id: 12,
    title: "Organic",
    description:
      "Organic is a responsive eco‑products landing page with a clean, modern design and adaptive layout.",
    role: "Front-End Developer",
    tech: ["JS", "HTML", "CSS"],
    image: "/images/organic.png",
    demo: "https://organic.chasov-dev.com/",
    code: "https://github.com/chasov-artem/organic-repo",
    logoImage: "/images/organic1.png",
  },
  {
    id: 11,
    title: "Flights App",
    description:
      "Flights is a responsive web application for searching and browsing flight options in real time. It features a clean, modern UI built with React and modular CSS, focusing on speed and user-friendly interactions. The project demonstrates API data fetching, dynamic rendering of flight results, and smooth navigation for both desktop and mobile users.",
    role: "Front-End Developer",
    tech: ["React", "CSS"],
    image: "/images/flights.png",
    demo: "https://flights.chasov-dev.com/",
    code: "https://github.com/chasov-artem/flights",
    logoImage: "/images/flights1.png",
  },
  {
    id: 10,
    title: "Posts App2",
    description:
      "Posts App2 is a Flutter Web app with full CRUD for posts, using Provider for state management and JSONPlaceholder as a REST API.",
    role: "Front-End Developer",
    tech: ["Flutter"],
    image: "/images/posts2-1.png",
    demo: "https://postsapp2.chasov-dev.com/",
    code: "https://github.com/chasov-artem/DOiT-2",
    logoImage: "/images/posts2-2.png",
  },
  {
    id: 9,
    title: "Posts App",
    description:
      "A responsive blog demo built with Next.js, Material-UI, and Redux. Features post browsing, creation, deletion, comments, search, and theme switching. Uses JSONPlaceholder API for mock data.",
    role: "Front-End Developer",
    tech: ["Next", "Redux", "Material-UI"],
    image: "/images/posts-1.png",
    demo: "https://postsapp.chasov-dev.com/",
    code: "https://github.com/chasov-artem/DOiT",
    logoImage: "/images/posts-2.png",
  },
  {
    id: 8,
    title: "CRM",
    description:
      "This is a learning CRM project built with Next.js 14, React Query, and mock APIs. It demonstrates dynamic routing, server-side rendering, and modern UI features like modal forms and real-time data updates.",
    role: "Front-End Developer",
    tech: ["Next", "React Query"],
    image: "/images/crm1.png",
    demo: "https://crm.chasov-dev.com/dashboard",
    code: "https://github.com/chasov-artem/crm",
    logoImage: "/images/crm2.png",
    featured: true,
    featuredOrder: 4,
    caseStudy: {
      problem: "CRM dashboard with dynamic routing, forms, and real-time data.",
      solution:
        "Next.js 14 + React Query, SSR, modal forms, mock API integration.",
      highlight: "Next.js 14, React Query, SSR, dynamic routing.",
    },
  },
  {
    id: 7,
    title: "TravelTrucks",
    description:
      "Travel Trucks is a campervan rental web application that allows users to browse available campervans, filter them by various parameters, view detailed information, and make reservations. An individual project.",
    role: "Front-End Developer",
    tech: ["React", "Redux"],
    image: "/images/traveltrucks.png",
    demo: "https://traveltrucks.chasov-dev.com/",
    code: "https://github.com/chasov-artem/TravelTrucks",
    logoImage: "/images/camper.png",
  },
  {
    id: 6,
    title: "SparkArt",
    description:
      "This is a landing page for a game. A page with a responsive design, a burger menu and a swiper for mobile devices. Developed all sections starting from the FAQ section and below. Team project(two developers and designer)",
    role: "Front-End Developer",
    tech: ["HTML", "CSS", "JS"],
    image: "/images/sparkart.png",
    demo: "https://dmytrok-goit.github.io/stp-7973/",
    code: "https://github.com/DmytroK-goit/stp-7973",
    logoImage: "/images/art.png",
  },
  {
    id: 5,
    title: "AquaTrack",
    description:
      "This is an app for controlling water consumption. With a backend created for the needs of the application, with login, responsive design, and water controlling features. I was responsible for the user panel section.",
    role: "Scrum Master and Front-End Developer",
    tech: ["React", "Redux", "Node"],
    image: "/images/aquatrack.png",
    demo: "https://aqua-track-group-01.vercel.app/",
    code: "https://github.com/DmytroK-goit/AquaTrack-group-01",
    logoImage: "/images/aqua.png",
  },
  {
    id: 4,
    title: "Phonebook",
    description:
      "A contact management app with secure login, real-time notifications, and a responsive, animated interface. I developed contact CRUD functionality, implemented JWT authorization, and designed the interactive home page. An individual project.",
    role: "Front-End Developer",
    tech: ["React", "Redux", "JWT"],
    image: "/images/phonebook.png",
    demo: "https://phonebook.chasov-dev.com/",
    code: "https://github.com/chasov-artem/goit-react-hw-08",
    logoImage: "/images/phone.png",
  },
  {
    id: 3,
    title: "Portfolio",
    description:
      "A developer portfolio website with animations, modal windows, and a swiper for smooth navigation. I was in charge of creating the covers section. Team project.",
    role: "Scrum Master and Front-End Developer",
    tech: ["HTML", "CSS", "JS"],
    image: "/images/portfolio.png",
    demo: "https://dmytrok-goit.github.io/project-js-group02/",
    code: "https://github.com/DmytroK-goit/project-js-group02",
    logoImage: "/images/port.png",
  },
  {
    id: 2,
    title: "Watchcharm",
    description:
      "A website for a wristwatch sales company, featuring a responsive design. I was responsible for developing the sales section. Team project.",
    role: "Scrum Master and Front-End Developer",
    tech: ["HTML", "CSS"],
    image: "/images/watchcharm2.png",
    demo: "https://denismayboroda.github.io/project-Do-your-first-step/",
    code: "https://github.com/DenisMayboroda/project-Do-your-first-step",
    logoImage: "/images/watch.png",
  },
  {
    id: 1,
    title: "WebStudio",
    description:
      "A website for the WebStudio company featuring responsive design, animation effects, and modal windows. An individual project.",
    role: "Front-End Developer",
    tech: ["HTML", "CSS"],
    image: "/images/webstudio.png",
    demo: "https://webstudio.chasov-dev.com/",
    code: "https://github.com/chasov-artem/goit-markup-hw-06/",
    logoImage: "/images/web.png",
  },
];

// Featured projects (order: mini-messenger, phrase-editor, CRM, Billiard-servis, Nanny Services)
export const featuredProjects = projects
  .filter((p) => p.featured)
  .sort((a, b) => a.featuredOrder - b.featuredOrder);

export const otherProjects = projects.filter((p) => !p.featured);

// All projects in display order: Featured first, then others
export const projectsOrdered = [...featuredProjects, ...otherProjects];
